import type {
  GenericSearchParam,
  LinkedInProfile,
  ProfileSearchParams,
  SearchParamWithImage,
} from "common/types";

import { useSearchParamsContext } from "../SearchParamsContext";

export default function useSearchParams(
  optionsKey?: keyof Omit<ProfileSearchParams, "keywords">,
) {
  const { searchParams, setSearchParams } = useSearchParamsContext();

  let appliedSearchParamValues: Array<
    GenericSearchParam | SearchParamWithImage | LinkedInProfile
  >;
  if (optionsKey) {
    if (optionsKey === "followers_of") {
      appliedSearchParamValues = searchParams.followers_of
        ? [searchParams.followers_of]
        : [];
    } else {
      appliedSearchParamValues = searchParams[optionsKey] as Array<
        GenericSearchParam | SearchParamWithImage
      >;
    }
  }

  function addSearchParamValue(
    searchParamKey: keyof Omit<
      ProfileSearchParams,
      "keywords" | "followers_of"
    >,
    value: GenericSearchParam | SearchParamWithImage,
  ) {
    setSearchParams({
      [searchParamKey]: [...searchParams[searchParamKey], value],
    });
  }
  function removeSearchParamValue(
    searchParamKey: keyof Omit<
      ProfileSearchParams,
      "keywords" | "followers_of"
    >,
    value: GenericSearchParam | SearchParamWithImage,
  ) {
    setSearchParams({
      [searchParamKey]: searchParams[searchParamKey].filter(
        ({ urn }) => urn !== value.urn,
      ),
    });
  }

  function setSearchParamValue<
    T extends keyof Omit<ProfileSearchParams, "keywords">,
  >(searchParamKey: T, value: ProfileSearchParams[T]) {
    setSearchParams({
      [searchParamKey]: value,
    });
  }

  return {
    removeSearchParamValue,
    addSearchParamValue,
    setSearchParamValue,
    appliedSearchParamValues,
  };
}
